export default __webpack_public_path__ + "messages.528ad19e51c89bbb.svg";